export const provinciasOptions = [
  // --- España ---
  { value: "España", label: "España (Nacional)" },
  { value: "A Coruña", label: "A Coruña" },
  { value: "Albacete", label: "Albacete" },
  { value: "Alicante/Alacant", label: "Alicante/Alacant" },
  { value: "Almería", label: "Almería" },
  { value: "Araba/Álava", label: "Araba/Álava" },
  { value: "Asturias", label: "Asturias" },
  { value: "Ávila", label: "Ávila" },
  { value: "Badajoz", label: "Badajoz" },
  { value: "Barcelona", label: "Barcelona" },
  { value: "Bizkaia", label: "Bizkaia" },
  { value: "Burgos", label: "Burgos" },
  { value: "Cáceres", label: "Cáceres" },
  { value: "Cádiz", label: "Cádiz" },
  { value: "Cataluña", label: "Cataluña" },
  { value: "Canarias", label: "Canarias" },
  { value: "Gran Canaria", label: "Gran Canaria" },
  { value: "Cantabria", label: "Cantabria" },
  { value: "Castellón/Castelló", label: "Castellón/Castelló" },
  { value: "Ceuta", label: "Ceuta" },
  { value: "Ciudad Real", label: "Ciudad Real" },
  { value: "Córdoba", label: "Córdoba" },
  { value: "Cuenca", label: "Cuenca" },
  { value: "El Hierro", label: "El Hierro" },
  { value: "Fuerteventura", label: "Fuerteventura" },
  { value: "Girona", label: "Girona" },
  { value: "Gipuzkoa", label: "Gipuzkoa" },
  { value: "Granada", label: "Granada" },
  { value: "Guadalajara", label: "Guadalajara" },
  { value: "Guarda", label: "Guarda" },
  { value: "Huelva", label: "Huelva" },
  { value: "Huesca", label: "Huesca" },
  { value: "Illes Balears", label: "Illes Balears" },
  { value: "Jaén", label: "Jaén" },
  { value: "La Gomera", label: "La Gomera" },
  { value: "La Palma", label: "La Palma" },
  { value: "La Rioja", label: "La Rioja" },
  { value: "Lanzarote", label: "Lanzarote" },
  { value: "León", label: "León" },
  { value: "Lleida", label: "Lleida" },
  { value: "Lugo", label: "Lugo" },
  { value: "Madrid", label: "Madrid" },
  { value: "Málaga", label: "Málaga" },
  { value: "Melilla", label: "Melilla" },
  { value: "Murcia", label: "Murcia" },
  { value: "Navarra", label: "Navarra" },
  { value: "Ourense", label: "Ourense" },
  { value: "Palencia", label: "Palencia" },
  { value: "Pontevedra", label: "Pontevedra" },
  { value: "Salamanca", label: "Salamanca" },
  { value: "Segovia", label: "Segovia" },
  { value: "Sevilla", label: "Sevilla" },
  { value: "Soria", label: "Soria" },
  { value: "Tarragona", label: "Tarragona" },
  { value: "Tenerife", label: "Tenerife" },
  { value: "Teruel", label: "Teruel" },
  { value: "Toledo", label: "Toledo" },
  { value: "Valencia/València", label: "Valencia/València" },
  { value: "Valladolid", label: "Valladolid" },
  { value: "Zamora", label: "Zamora" },
  { value: "Zaragoza", label: "Zaragoza" },

  // --- Portugal (opcional) ---
  { value: "Aveiro", label: "Aveiro" },
  { value: "Beja", label: "Beja" },
  { value: "Braga", label: "Braga" },
  { value: "Bragança", label: "Bragança" },
  { value: "Castelo Branco", label: "Castelo Branco" },
  { value: "Coimbra", label: "Coimbra" },
  { value: "Évora", label: "Évora" },
  { value: "Faro", label: "Faro" },
  { value: "Guarda", label: "Guarda" },
  { value: "Leiria", label: "Leiria" },
  { value: "Lisboa", label: "Lisboa" },
  { value: "Portalegre", label: "Portalegre" },
  { value: "Porto", label: "Porto" },
  { value: "Santarém", label: "Santarém" },
  { value: "Setúbal", label: "Setúbal" },
  { value: "Viana do Castelo", label: "Viana do Castelo" },
  { value: "Vila Real", label: "Vila Real" },
  { value: "Viseu", label: "Viseu" },
];
